<p-dialog header="{{caption}}" [(visible)]="display" [modal]="true" [resizable]="true" (onHide)="onCancel()" width="1000">
    <div class="placeholdercontainer">
        <app-hif-member-data [membercin]="membercin"></app-hif-member-data>
    </div>
</p-dialog>
